import React, { useMemo } from "react";
import { Grid, GridToolbar } from "@progress/kendo-react-grid";

import "./grid.css"

const GenericGrid = ({
  data = [],
  columns = [],
  dataState,
  onDataStateChange,
  pageable = false,
  sortable = false,
  filterable = false,
  groupable = false,
  style = {},
  className = "",
  rowRender,
  cellRender,
  headerCellRender,
  toolbar,
  selectable,
  editField,
  dataItemKey = "id",
  selectedField = "selected",
  onSelectionChange,
  storageField = "" // selected row is retrieved from localStorage
}) => {

  // Compute processedData dynamically using useMemo
  const processedData = useMemo(() => {
    const selectedItem = JSON.parse(localStorage.getItem(storageField));
    return data.map(item => ({
      ...item,
      [selectedField]: selectedItem  ? selectedItem[dataItemKey] === item[dataItemKey] : false
    }));
  }, [data, storageField, dataItemKey, selectedField]);

  return (
    <Grid
      style={style}
      className={className}
      data={processedData}
      {...dataState}
      pageable={pageable}
      sortable={sortable}
      filterable={filterable}
      groupable={groupable}
      onDataStateChange={onDataStateChange}
      rowRender={rowRender}
      cellRender={cellRender}
      headerCellRender={headerCellRender}
      selectable={selectable}
      editField={editField}
      dataItemKey={dataItemKey}
      selectedField={selectedField}
      total={processedData.length}
        onRowClick={e => {
    if (!selectable || (selectable.enabled === false)) return; // skip selection
    onSelectionChange?.(e);
  }}
    >
      {toolbar && <GridToolbar>{toolbar}</GridToolbar>}
      {columns}
    </Grid>
  );
};

export default GenericGrid;
